import clsx from 'clsx';
import React, { useState } from 'react';

import { createLeadLockedHomepage } from '../../../application/javascripts/forms/locked-homepage-lead-capture';
import { generateTrackingAttributes } from '../../../utils/tracking';
import GdprOptIn from './GdprOptIn';

interface LeadDetails {
  article_title?: string;
  briefing_title?: string;
  newsletter_name?: string;
  org_chart_title?: string;
  homepage_conversion?: boolean;
  directory_conversion?: boolean;
  project_name?: string;
}

interface LockedLeadCaptureFormProps {
  buttonText: string;
  emailPlaceholderText?: string;
  endpointUri: string;
  forceEmailAuth?: boolean;
  formLocation?: string;
  isGdprLead?: boolean;
  leadDetails?: LeadDetails;
  leadType: string;
  redirectUri: string;
  trackingProps?: { [key: string]: string };
}

export default function LockedLeadCaptureForm({
  buttonText,
  emailPlaceholderText = 'Enter your email',
  endpointUri,
  forceEmailAuth = false,
  formLocation,
  isGdprLead = false,
  leadDetails = {},
  leadType,
  redirectUri,
  trackingProps = {},
}: LockedLeadCaptureFormProps) {
  const trackClick = Object.keys(trackingProps).length > 0;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.SyntheticEvent) => {
    setIsSubmitting(true);
    e.preventDefault();

    await createLeadLockedHomepage(e);

    setIsSubmitting(false);
  };

  return (
    <div className="lock-lead-capture-form">
      <div className="get-started-form-group">
        <form className="get-started-action-group">
          <input type="text" className="get-started-input" placeholder={emailPlaceholderText} />
          <span className="get-started-btn-container">
            {isGdprLead && <GdprOptIn />}
            <button
              type="submit"
              className={clsx('get-started-button', {
                'track-click': trackClick,
                disabled: isSubmitting,
              })}
              data-submit-uri={endpointUri}
              data-redirect-uri={redirectUri}
              data-lead-type={leadType}
              data-force-email-auth={forceEmailAuth}
              data-lead-details={JSON.stringify(leadDetails)}
              data-form-location={formLocation}
              onClick={handleSubmit}
              {...generateTrackingAttributes({
                name: 'subscribe',
                page: window.location.href,
                ...trackingProps,
              })}
            >
              {buttonText}
            </button>
          </span>
        </form>
        <div className="get-started-error"></div>
      </div>
    </div>
  );
}
